import React from 'react'
import { Helmet } from 'react-helmet'

const Room = () => {
  return (
    <>
      <Helmet>
         <meta charSet="utf-8" />
         <title>Facilities at Hotel Ramay Palace - Ayodhya Ram Janmbhoomi</title>        ''  
         <link rel="canonical" href="https://ramaypalace.com/advantage" />
         <meta name='description' content='Enjoy comfortable facilities in Hotel Ramay Palace near Ram Janmbhoomi Ayodhya. We have Parking, Spacious and AC Rooms, and other amenities'/>
      </Helmet>
      <div className="back_re">
         <div className="container">
            <div className="row">
               <div className="col-md-12">
                  <div className="title">
                     <h2>Facilities</h2>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div  className="our_room facility">
         <div className="container">
            <div className="row">
               <div className="col-md-12">
                  <div className="titlepage">
                     {/* <h2>Reasons to Choose us</h2> */}
                     {/* <p> Make your stay memorable with Us </p> */}
                  </div>
               </div>
            </div>
            <div className="container mobp">
               <div className="row ">
                  {/* <div className="col-md-12 "> */}
                     <div className='row align-items-center '>
                     <div className="col-md-5 col-sm-6">
                        <div id="serv_hover"  className="room">
                           <div className="room_img animated fadeInUp">
                              <figure><img src="images/Images/Facilities/Hotel-Post-1280x854-01.jpg" alt="Parking Facility"/></figure>
                           </div>
                        </div>
                     </div>
                        <div className="col-md-7 col-sm-6 animated fadeInUp">
                           <h2>Parking accommodations</h2>
                           <p>Enjoy hassle-free parking during your stay at our hotel. Our convenient parking accommodations make it easy for guests to arrive and depart without worrying about finding a parking spot or navigating unfamiliar streets.

                           We offer ample on-site parking with easy access to the hotel entrance. Our parking lot is well-lit and monitored by security cameras for your safety and peace of mind. Whether you're traveling alone or with a group, we have plenty of space to accommodate your vehicle.</p>
                        </div>
                     </div>
                  {/* </div> */}
               </div>
               </div>

               <div className="container mobp">
               <div className="row ">
                  {/* <div className="col-md-12 "> */}
                     <div className='row align-items-center rev'>
                        <div className="col-md-7 col-sm-6 animated fadeInUp">
                           <h2>Commodious</h2>
                           <p>Experience spacious luxury at our hotel. Our accommodations are designed to provide ample space and comfort, with generously sized rooms and suites that offer plenty of room to stretch out and relax. Enjoy oversized beds with plush bedding, large windows that provide plenty of natural light, and stylish décor that creates a warm and inviting atmosphere.

                           Our public areas are equally commodious, with expansive lobbies and lounges that provide plenty of space to gather and socialize. Enjoy comfortable seating, complimentary Wi-Fi, and a welcoming ambiance that will make you feel right at home.</p>
                        </div>
                        <div className="col-md-5 col-sm-6 animated fadeInUp">
                           <div id="serv_hover"  className="room">
                              <div className="room_img">
                                 <figure><img src="images/Images/Facilities/Hotel-Post-1280x854-02.jpg" alt="Parking Facility"/></figure>
                              </div>
                              {/* <div className="bed_room">
                                 <h3>Bed Room</h3>
                                 <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                              </div> */}
                           </div>
                        </div>
                     </div>
                  {/* </div> */}
               </div>
               </div>
               {/*Chanages in div above close*/}
               <div className="container mobp">
               <div className="row">
                  {/* <div className="col-md-12 "> */}
                     <div className='row align-items-center'>
                        <div className="col-md-5 col-sm-6">
                           <div id="serv_hover"  className="room">
                              <div className="room_img animated fadeInUp">
                                 <figure><img src="images/Images/Facilities/Hotel-Post-1280x854-03.jpg" alt="Parking Facility"/></figure>
                              </div>
                              {/* <div className="bed_room">
                                 <h3>Bed Room</h3>
                                 <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                              </div> */}
                           </div>
                        </div>
                        <div className="col-md-7 col-sm-6 animated fadeInUp">
                           <h2>Lavish and comfortable</h2>
                           <p>Indulge in the ultimate comfort and luxury during your stay at our hotel. Our lavish and comfortable rooms are designed to provide the perfect escape from the stresses of everyday life, with sumptuous furnishings, plush bedding, and all the amenities you need for a relaxing and rejuvenating stay.

                           Our rooms feature oversized beds with high-quality linens, comfortable seating areas, and ample storage space for your belongings. Enjoy state-of-the-art technology including flat-screen TVs with premium cable channels, complimentary Wi-Fi, and convenient USB charging ports.</p>
                        </div>
                     </div>
                  {/* </div> */}
               </div>
               </div>
               <div className="container mobp">
               <div className="row ">
                  {/* <div className="col-md-12 "> */}
                        <div className='row align-items-center rev'>
                           <div className="col-md-7 col-sm-6 animated fadeInUp">
                              <h2>Fully climate-controlled</h2>
                              <p>Escape the heat and humidity outside and step into cool comfort in our fully air-conditioned hotel rooms. We understand the importance of a comfortable and relaxing environment during your stay, which is why all of our rooms are equipped with state-of-the-art air conditioning systems.

                              Our air conditioning units are regularly maintained to ensure maximum efficiency, and we strive to keep a consistent and comfortable temperature in all of our guest rooms. Whether you're looking to escape the summer heat or simply prefer a cooler sleeping environment, our air-conditioned rooms are the perfect solution.</p>
                           </div>
                           <div className="col-md-5 col-sm-6 animated fadeInUp">
                              <div id="serv_hover"  className="room">
                                 <div className="room_img">
                                    <figure><img src="images/Images/Facilities/Hotel-Post-1280x854-05.jpg" alt="Parking Facility"/></figure>
                                 </div>
                                 {/* <div className="bed_room">
                                    <h3>Bed Room</h3>
                                    <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                                 </div> */}
                              </div>
                           </div>
                        </div>
                     {/* </div> */}
               </div>
               </div>
               <div className="container mobp">
               <div className="row">
                  {/* <div className="col-md-12"> */}
                     <div className='row align-items-center '>
                        <div className="col-md-5 col-sm-6 animated fadeInUp">
                           <div id="serv_hover"  className="room">
                              <div className="room_img">
                                 <figure><img src="images/Images/Facilities/Hotel-Post-1280x854-06.jpg" alt="Parking Facility"/></figure>
                              </div>
                           </div>
                        </div>
                        <div className="col-md-7 col-sm-6 animated fadeInUp">
                           <h2>Walking distance to Shree Ram Janmbhoomi</h2>
                           <p>Discover the wonders of Shree Ram Janmbhoomi during your stay at our hotel, conveniently located just a short walk away. Immerse yourself in the rich history and cultural significance of this revered site, and enjoy the convenience of staying just steps away from all the action.

                           Our hotel is situated in a prime location, offering easy access to Shree Ram Janmbhoomi and other nearby attractions. Our friendly staff is always happy to provide insider tips and recommendations for exploring the area, from the best local restaurants to the most exciting activities and events.</p>
                        </div>
                     </div>
                  {/* </div> */}
               </div>
               </div>
               <div className="container mobp">
               <div className="row">
                  {/* <div className="col-md-12 "> */}
                     <div className='row align-items-center rev'>
                        <div className="col-md-7 col-sm-6 animated fadeInUp">
                           <h2>Affordable pricing for a full range of amenities</h2>
                           <p>At our hotel, we believe that luxury and affordability can go hand in hand. That's why we're proud to offer a full range of amenities at an affordable price, making us the perfect choice for budget-conscious travelers who don't want to sacrifice comfort and convenience.

                           Our rooms are designed to provide a comfortable and relaxing environment, featuring all the amenities you need for a restful stay, including high-quality linens, comfortable bedding, and a range of entertainment options. In addition, our hotel offers a variety of on-site amenities, including a fitness center, swimming pool, and a range of dining options, so you can enjoy all the comforts of home without breaking the bank.</p>
                        </div>
                        <div className="col-md-5 col-sm-6 animated fadeInUp">
                           <div id="serv_hover"  className="room">
                              <div className="room_img">
                                 <figure><img src="images/Images/Facilities/Hotel-Post-1280x854-07.jpg" alt="Parking Facility"/></figure>
                              </div>
                              {/* <div className="bed_room">
                                 <h3>Bed Room</h3>
                                 <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                              </div> */}
                           </div>
                        </div>
                     </div>
                  {/* </div> */}
               </div>
               </div>
               {/* <div className="col-md-4 col-sm-6">
                  <div id="serv_hover"  className="room">
                     <div className="room_img">
                        <figure><img src="images/Images edit/1280x854/Hotel-Post-1280x854-03.jpg" alt="Luxury & comfy room"/></figure>
                     </div>
                     <div className="bed_room">
                        <h3>Bed Room</h3>
                        <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                     </div>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6">
                  <div id="serv_hover"  className="room">
                     <div className="room_img">
                        <figure><img src="images/Images edit/1280x854/Hotel-Post-1280x854-05.jpg" alt="fully AC"/></figure>
                     </div>
                     <div className="bed_room">
                        <h3>Bed Room</h3>
                        <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                     </div>
                  </div>
               </div>
               </div>
               <div className="col-md-4 col-sm-6">
                  <div id="serv_hover"  className="room">
                     <div className="room_img">
                        <figure><img src="images/Images edit/1280x854/Hotel-Post-1280x854-06.jpg" alt="300m from Shri Ram Janmbhoomi"/></figure>
                     </div>
                     <div className="bed_room">
                        <h3>Bed Room</h3>
                        <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                     </div>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6">
                  <div id="serv_hover"  className="room">
                     <div className="room_img">
                        <figure><img src="images/Images edit/1280x854/Hotel-Post-1280x854-07.jpg" alt="Affordable Price"/></figure>
                     </div>
                     <div className="bed_room">
                        <h3>Bed Room</h3>
                        <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there </p>
                     </div>
                  </div>*/}
               </div> 
            </div>
      

    </>
  )
}

export default Room
